// @flow

import React, {Component} from 'react';
import {withCssModule} from '@pb/kit-util-with-css-module';

import {VerticalAlign, VERTICAL_ALIGN_CLASSES} from './constants';
import styles from './table.component.module.styl';


const classNames = withCssModule(styles);

const getTableClasses = (props: TableProps) => classNames(
    'table',
    props.mix,
    {
        'table_fixed': props.fixed,
        'table_bordered-grid': props.borderedGrid,
        'table_bordered-columns': props.borderedColumns,
        'table_data-table-rows': props.dataTableRows,
    },
    VERTICAL_ALIGN_CLASSES('table')[props.verticalAlign || VerticalAlign.DEFAULT]
);
type VerticalAlignType = $Values<typeof VerticalAlign>;
/**
 * Table component Props
 */
type TableProps = {|
    /**
     * Callback for setting table node as ref
     */
    getRefTable?: (e: ?HTMLTableElement) => void,
    children: React$Node,
    /**
     * Make table layout to FIXED
     */
    fixed: boolean,
    /**
     * Border for all cells of table
     */
    borderedGrid: boolean,
    /**
     * If true, table will have borders between columns
     * */
    borderedColumns?: boolean,
    /**
     * If true, table rows will have height and padding like in data table
     * */
    dataTableRows?: boolean,
    /**
     * Mix for table
     */
    mix: string,
    /**
     * Table vertical align
     */
    verticalAlign?: VerticalAlignType,
|};

export class Table extends Component<TableProps> {
    table: ?HTMLTableElement;

    static defaultProps = {
        fixed: true,
        borderedGrid: false,
        mix: ''
    };

    componentDidMount() {
        if (this.props.getRefTable) {
            this.props.getRefTable(this.table);
        }
    }

    render() {
        return (
            <table
                ref={el => this.table = el}
                className={getTableClasses(this.props)}>
                {this.props.children}
            </table>
        );
    }
}


            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./constants");
